import * as ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';
import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataGridComponent } from '@app/shared/custom-component/data-grid/data-grid.component';
import { AccordionGridSection, AccordionGridSectionManager, ColumnConfig } from '@app/shared/models/accordion-grid-section.model';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs';
import { CommonService } from '@app/shared/services/common.service';
import { AlertService } from '@app/@core/services/alert.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '@pics-core/dynamic';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocalService } from '@app/@core/services/local.service';
import { HttpService } from '@app/@core/services/http.service';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';
import { LoaderService } from '@app/@core/services/loader.service';
import { DataGridVO } from '@app/shared/custom-component/data-grid/data-grid.model';
import { TemplateData } from './lea-dashboard.interface';
import { CommonModule } from '@angular/common';
import { ModalConfig } from '@app/shared/constants/modal.model';
import { ModalComponent } from '@app/shared/custom-component/modal/modal.component';
import { LEA_PORTAL_CONSTANT } from './lea-dashboard.constant';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { DxDataGridModule, DxButtonModule, DxPopupModule, DxTemplateModule } from 'devextreme-angular';
import { HttpClient } from '@angular/common/http';
import { SystemConfigurationService } from '@app/systemconfiguration/system-configuration.service';

@Component({
  selector: 'app-lea-dashboard',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    MatTooltipModule,
    PrimengModule,
    DxDataGridModule, DxButtonModule, DxPopupModule, DxTemplateModule,
    DataGridComponent
  ],
  templateUrl: './lea-dashboard.component.html',
  styleUrls: ['./lea-dashboard.component.scss']
})
export class LeaDashboardComponent implements OnInit, OnDestroy {

  dataTemplateHeaders: any[] = [];
  dataSubmissionHeaders: any[] = [];
  templateOptions: string[] = [];
  private destroy$ = new Subject<void>();
  uploadData: any = {
    file: null,
    category: '',
    docType: ''
  };
  oneFileIsRequired: boolean;
  oneFileIsRequiredError: string;
  categoryError: string;
  docTypeError: string;
  filteredDocumentTypes: any[] = [];
  categories: any[] = [];
  uploadError: string | null = null;
  errorMessages: any[] = [];
  errorMessage: any = {};
  saveEnable: boolean = false;
  isLoading: boolean = false;
  templateDataGridConfig: DataGridVO = DataGridVO.create({});
  // My template data Properties
  templateData: TemplateData = {
    template_name: '',
    uploaded_by: '',
    uploaded_date: '',
  };
  visibleColumns: { [key: string]: boolean } = {};
  allColumns: any[] = [];
  filteredapplicationData: any[] = [];
  dataTemplateArray: any[] = [];
  templateError: string = '';

  // Section manager for accordion grids
  sectionManager = new AccordionGridSectionManager();
  dataTemplateSection: AccordionGridSection;
  dataSubmissionSection: AccordionGridSection;

  // ViewChild references to access data-grid components
  @ViewChild('dataTemplateGrid') dataTemplateGrid: DataGridComponent;
  @ViewChild('dataSubmissionGrid') dataSubmissionGrid: DataGridComponent;
  @ViewChild('fileInputRef') fileInputRef!: ElementRef<HTMLInputElement>;

  templateLeaHistoryData: any = [];
  templateLeagridConfig = [
    {
      columnDef: 'template_name',
      header: 'Template Name',
      filter: true,
      width: 260
    },
    {
      columnDef: 'updated_date',
      header: 'Uploaded Date',
      filter: true,
      dateFormat: 'date',
      width: 140
    },
    {
      columnDef: 'updated_by',
      header: 'Uploaded By',
      filter: true,
      width: 260
    }
  ];
  submissiontemplateLeagridConfig = [
    {
      columnDef: 'file_name',
      header: 'Filename',
      filter: true,
      width: 260
    },
    {
      columnDef: 'template_name',
      header: 'Template Name',
      filter: true,
      width: 260
    },
    {
      columnDef: 'errorcount',
      header: 'Error Count',
      filter: true,
      width: 260
    },
    {
      columnDef: 'uploaded_at',
      header: 'Uploaded Date',
      filter: true,
      dateFormat: 'date',
      width: 140
    },
    {
      columnDef: 'uploaded_by',
      header: 'Uploaded By',
      filter: true,
      width: 260
    }
  ];
  isShowEdit: boolean = true;
  isShowDelete: boolean = true;
  isVisible = true;
  isActionVisible = true;
  actionColumnWidth: number = 120;
  portalTemplateNames: any = [];
  portalSubmissionList: any = [];
  referenceDocumentsList: any[] = [];
  referenceDocumentsGridConfig = [
    {
      columnDef: 'file_name',
      header: 'Document Name',
      filter: true,
      width: 260
    },
    {
      columnDef: 'created_at',
      header: 'Uploaded Date',
      filter: true,
      dateFormat: 'date',
      width: 140
    },
    {
      columnDef: 'uploaded_by',
      header: 'Uploaded By',
      filter: true,
      width: 260
    }
  ];
  refDocDataGridConfig: DataGridVO = DataGridVO.create({
    customHeaders: [
      { dataField: 'file_name', caption: 'Document Name', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'string' } },
      { dataField: 'created_date', caption: 'Uploaded Date', allowFiltering: true, dataType: 'date', allowSearch: { isSearchEnable: true, type: 'date' } },
      { dataField: 'created_by', caption: 'Uploaded By', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'string' } }
    ],
    showActionsColumn: true,
    data: [],
    role: '',
    activeTab: ''
  });
  template_name: any;
  lookupToast: any = [];
  showText: boolean = false;
  currentPageSize: any = 10;
  displayMode: string = 'compact';
  @Input() set pageSize(value: number) {
    if (value) {
      this.currentPageSize = value;
    } else {
      this.currentPageSize = 20;
    }
  }
  lookupErrorMessages: any = [];
  showErrorBanner: boolean = false;
  errorBannerMessage: string = '';
  schoolYears: any[] = [];
  schoolYearError: string = '';

  constructor(
    private commonService: CommonService,
    private readonly alertService: AlertService,
    private modalService: NgbModal,
    private authServices: AuthService,
    private cdr: ChangeDetectorRef,
    private sessionStorage: LocalService,
    private httpService: HttpService,
    private http: HttpClient,
    private loaderService: LoaderService,
    private systemConfigurationService: SystemConfigurationService
  ) {
    this.initializeSections(),
      this.filteredapplicationData = [];
  }

  ngOnInit() {
    this.getPortalTemplate();
    this.loadPortalTemplate();
    this.loadPortalSubmission();
    this.fetchSubmissionsList();
    this.fetchReferenceDocuments();
    this.getToastMessages();
    this.getErrorMessages();
    this.loadSchoolYears();
  }

  setActionColumnWidth(e) {
    const rows = e.component.getDataSource().items();

    let maxWidth = 120;

    console.log('Calculated action column width:', maxWidth);
    this.actionColumnWidth = maxWidth;
  }

  getPortalTemplate() {

    this.httpService.get(API_ENDPOINTS.DATA_TEMPLATES.GETPORTAL_TYPES + '/LEA')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          //this.portalTemplateNames = response?.data?.data?.data;

          // this.templateLeaHistoryData = data?.data?.data?.data;
          const groups = response?.data?.data?.data || [];

          const allTemplates = groups.reduce((acc, group) => {
            return acc.concat(group.data);
          }, []);

          this.portalTemplateNames = allTemplates.filter(f => f.template_category === 'LEA');
          const result = this.portalTemplateNames.filter(
            item => item.data_template_col_sel_id !== undefined
          );
          this.portalTemplateNames = result;
        },
        error: (error) => {
          this.alertService.error('Failed to load portal template data. Please try again.');
          this.isLoading = false;
          this.loaderService.hide();
        },
        complete: () => {
          this.isLoading = false;
          this.loaderService.hide();
        }
      })
  }

  onDownloadTemplateWithoutData(value: any) {
    let url = API_ENDPOINTS.DATA_TEMPLATES.DOWNLOAD_TEMPLATES;
    let contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const item = value.data;
    this.template_name = item.template_name;
       const identity_id = 0 ;
    this.httpService.getDownload1(url + '/' + item.data_template_col_sel_id + '/' + item.template_id + '/' + identity_id + '/' + false + '/' + false, contentType).subscribe({
      next: (blob: Blob) => {
        const downloadLink = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        downloadLink.href = objectUrl;
        downloadLink.download = this.template_name;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(objectUrl);
      }
    });

  }

  onDownloadTemplate(value: any) {
    let url = API_ENDPOINTS.DATA_TEMPLATES.DOWNLOAD_TEMPLATES;
    let contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const item = value.data;
    this.template_name = item.template_name;
    const identity_id = item.id ;
    this.httpService.getDownload1(url + '/' + item.data_template_col_sel_id + '/' + item.template_id + '/' + identity_id + '/' + false + '/' + true, contentType).subscribe({
      next: (blob: Blob) => {
        const downloadLink = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        downloadLink.href = objectUrl;
        downloadLink.download = this.template_name;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(objectUrl);
      }
    });

  }

  onDownloadErrorTemplate(value: any) {
    const item = value.data;
    this.template_name = item.template_name;
    let url = API_ENDPOINTS.DATA_TEMPLATES.DOWNLOAD_TEMPLATES;
    const identity_id = item.id ;
    let contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    this.httpService.getDownload1(url + '/' + item.data_template_col_sel_id + '/' + item.template_id + '/' + identity_id + '/' + true + '/' + true, contentType).subscribe({
      next: (blob: Blob) => {
        const downloadLink = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        downloadLink.href = objectUrl;
        downloadLink.download = this.template_name;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(objectUrl);
      }
    });

  }

  /** Returns the start/end year of the current school year (July 1 – June 30). */
  private getCurrentSchoolYear(): { startYear: number; endYear: number } {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth(); // 0-indexed; July = 6
    return month >= 6
      ? { startYear: year, endYear: year + 1 }
      : { startYear: year - 1, endYear: year };
  }

  private getSchoolYearLabel(date: Date): string {
    const year = date.getFullYear();
    const month = date.getMonth();
    const startYear = month >= 6 ? year : year - 1;
    return `${startYear}-${startYear + 1}`;
  }

fetchSubmissionsList() {
    this.httpService.get(API_ENDPOINTS.DATA_TEMPLATES.FETCH_SUBMISSION_LIST + '/' + 1)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          const raw = response?.data?.data?.data || [];
          const currentSY = this.getCurrentSchoolYear();
          const currentCycleStart = new Date(currentSY.startYear, 6, 1); 

          this.portalSubmissionList = raw.map((item: any) => {
            // Resolve school year label
            let schoolYearLabel: string;
            const rawSY = item.school_year ?? item.schoolYear ?? null;
            const uploadDate = item.uploaded_at ? new Date(item.uploaded_at) : null;

            if (rawSY) {
              // Try to map via lookup; fall back to raw value
              const match = this.schoolYears.find((sy: any) => String(sy.key) === String(rawSY));
              schoolYearLabel = match ? match.value : String(rawSY);
            } else {
              // No field in response — derive from uploaded_at date
              schoolYearLabel =
                uploadDate && !isNaN(uploadDate.getTime())
                  ? this.getSchoolYearLabel(uploadDate)
                  : `${currentSY.startYear}-${currentSY.endYear}`;
            }

            // Mark as Archived when uploaded before the current school year cycle (July 1 – June 30)
            const syStartYear = parseInt(schoolYearLabel.split('-')[0], 10);
            const status =
              uploadDate && !isNaN(uploadDate.getTime()) && uploadDate < currentCycleStart
                ? 'Archived'
                : (item.status || '');

            return { ...item, school_year: schoolYearLabel, status };
          });
        },
        error: (error) => {
          this.alertService.error('Failed to load portal template data. Please try again.');
          this.isLoading = false;
          this.loaderService.hide();
        },
        complete: () => {
          this.isLoading = false;
          this.loaderService.hide();
        }
      })
  }

  fetchReferenceDocuments() {
    this.httpService.get(API_ENDPOINTS.DATA_TEMPLATES.FETCH_ACTIVE_REFERENCE_DOCUMENTS + '/LEA')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          this.referenceDocumentsList = (response?.data?.data || []).map((item: any) => {
            const rawDate = item.created_date ?? item.updated_date ?? null;
            return { ...item, created_date: rawDate ? new Date(rawDate) : null };
          });
          this.refDocDataGridConfig = DataGridVO.create({
            ...this.refDocDataGridConfig,
            data: this.referenceDocumentsList.map(item => ({
              ...item,
              file_name: this.removeFileExtension(item.file_name)
            }))
          });
        },
        error: (error:any) => {
          this.alertService.error('Failed to load reference documents. Please try again.');
        }
      });
  }

  onDownloadReferenceDocument(data: any) {
    const item = data.data;
    const refDocId = Number(item?.ref_document_id);
    const fileName = String(item?.file_name || `document_${refDocId}`);
    if (!Number.isFinite(refDocId) || refDocId <= 0) {
      this.alertService.error('Document information is missing');
      return;
    }
    this.httpService.post(API_ENDPOINTS.DATA_TEMPLATES.DOWNLOAD_REFERENCE_DOCUMENT, { ref_document_id: refDocId })
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          const fileUrl =
            response?.data?.data?.p_document_blob?.file_url ||
            response?.data?.data?.p_document_blob?.fileUrl ||
            response?.data?.data?.p_document_blob?.strfileHash ||
            response?.data?.file_url ||
            response?.data?.fileUrl ||
            response?.data?.url ||
            response?.file_url ||
            null;
          if (!fileUrl) {
            this.alertService.error('Failed to download reference document.');
            return;
          }
          fetch(fileUrl)
            .then(res => res.blob())
            .then(blob => {
              FileSaver.saveAs(blob, fileName);
              this.alertService.success('Document downloaded successfully.');
            })
            .catch(() => this.alertService.error('Failed to download reference document.'));
        },
        error: () => {
          this.alertService.error('Failed to download reference document. Please try again.');
        }
      });
  }

  getToastMessages(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.systemConfigurationService.getToastMessages().subscribe({
        next: (data: any) => {
          resolve();
          console.log(data?.data);
          const transformLookupArray = (arr: any[]): { [key: string]: string } => {
            const obj: { [key: string]: string } = {};
            if (Array.isArray(arr)) {
              arr.forEach(lookupItem => {
                if (lookupItem.key && lookupItem.value) {
                  obj[lookupItem.key] = lookupItem.value;
                }
              });
            }
            return obj;
          };
          this.lookupToast = transformLookupArray(data?.data);
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }


















  /**
    * Load section headers from JSON and create section
    */
  private loadSectionHeaders(
    sectionKey: string,
    sectionTitle: string,
    jsonPath: string,
    showExport: boolean = true,
    showColumnChooser: boolean = true,
    customButtons: any[] = []
  ): void {
    this.commonService
      .getHeaderData(sectionKey, jsonPath)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (headers: any) => {
          if (Array.isArray(headers)) {
            const columns: ColumnConfig[] = headers.map((h: any) => ({
              key: h.dataField,
              label: h.caption || h.dataField,
              disabled: h.dataField === 'application_id'
            }));

            const section = this.sectionManager.createSection(
              sectionKey,
              sectionTitle,
              columns,
              [],
              '',
              showExport,
              showColumnChooser,
              customButtons
            );
            console.log('SECTION', section)

            // Assign to the appropriate section property
            if (sectionKey === 'dataTemplateHeaders') this.dataTemplateSection = section;
            else if (sectionKey === 'dataSubmissionHeaders') this.dataSubmissionSection = section;
          }
        }
      });
  }

  private initializeSections(): void {
    // Load Data Template section
    this.loadSectionHeaders(
      'dataTemplateHeaders',
      'Data Templates',
      '../assets/metadata/data-template-header.json'
    );

    // Load Data Submission section
    this.loadSectionHeaders(
      'dataSubmissionHeaders',
      'Data Submissions',
      '../assets/metadata/data-submissions-headers.json'
    );
  }

  private mapTemplateData(data: any): void {
    // Map template Data
    this.templateData = {
      template_name: data.template_name || '',
      uploaded_by: data.uploaded_by || '',
      uploaded_date: data.uploaded_date ? new Date(data.uploaded_date) : null
    };

    console.log('Mapped template data:', this.templateData);

    // Ensure headers are available before creating grid config
    if (!this.dataTemplateHeaders || this.dataTemplateHeaders.length === 0) {
      // Use default headers if not loaded yet
      this.dataTemplateHeaders = [
        { dataField: 'template_name', caption: 'Template Name', label: 'Template Name', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'string' } },
        { dataField: 'uploaded_date', caption: 'Uploaded Date', label: 'Uploaded Date', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'date' } },
        { dataField: 'uploaded_by', caption: 'Uploaded By', label: 'Uploaded By', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'string' } },

      ];

      // Initialize visible columns
      this.visibleColumns = {};
      this.dataTemplateHeaders.forEach(header => {
        this.visibleColumns[header.dataField] = true;
      });
      this.allColumns = this.dataTemplateHeaders;
      console.log('ALL COLUMNS', this.allColumns)
    }

    // Update grid config with the mapped data
    this.templateDataGridConfig = DataGridVO.create({
      customHeaders: this.dataTemplateHeaders,
      visibleColumns: this.visibleColumns,
      data: this.filteredapplicationData,
      showNewDocumentIcon: true
    });

    // Load the documents data into the grid after mapping
    this.loadTemplateData();
  }

  loadTemplateData() {
    // Load License Requirements data
    if (Array.isArray(this.dataTemplateArray) && this.dataTemplateArray.length > 0) {
      const dataTemplate = this.dataTemplateArray.map(req => ({
        template_name: req.template_name,
        uploaded_by: req.uploaded_by,
        uploaded_date: req.uploaded_date,
      }));
      this.sectionManager.updateSectionData('dataTemplateHeaders', this.dataTemplateArray);
    } else {
      this.sectionManager.updateSectionData('dataTemplateHeaders', []);
    }
  }



  // Grid Actions handlers for Data Template
  onDataTemplateExport(): void {
    this.downloadExcelForSection('dataTemplateHeaders');
  }

  // Grid Actions handlers for Data Submission
  onDataSubmissionExport(): void {
    this.downloadExcelForSection('dataSubmissionHeaders');
  }

  onDataTemplateColumnChooserToggle(): void {
    this.sectionManager.toggleColumnChooser('dataTemplateHeaders');
  }

  onDataSubmissionColumnChooserToggle(): void {
    this.sectionManager.toggleColumnChooser('dataSubmissionHeaders');
  }

  onDataTemplateColumnToggle(event: { key: string; col: ColumnConfig }): void {
    this.sectionManager.toggleColumnVisibility('dataTemplateHeaders', event.key);
  }

  onDataTemplateColumnChooserClose(): void {
    this.sectionManager.closeColumnChooser('dataTemplateHeaders');
  }

  onDataSubmissionColumnToggle(event: { key: string; col: ColumnConfig }): void {
    this.sectionManager.toggleColumnVisibility('dataSubmissionHeaders', event.key);
  }

  onDataSubmissionColumnChooserClose(): void {
    this.sectionManager.closeColumnChooser('dataSubmissionHeaders');
  }


  downloadExcelForSection(sectionId: string): void {
    const section = this.sectionManager.getSection(sectionId);
    if (!section) return;

    // Get the appropriate data-grid component based on section ID
    let dataGridComponent: DataGridComponent | null = null;
    if (sectionId === 'dataTemplateHeaders') {
      dataGridComponent = this.dataTemplateGrid;
    } else if (sectionId === 'dataSubmissionHeaders') {
      dataGridComponent = this.dataSubmissionGrid;
    }

    // Get filtered data from the data-grid component if available, otherwise use section data
    let rows: any[] = [];
    if (dataGridComponent) {
      rows = dataGridComponent.getFilteredDataFromGrid();
    } else {
      rows = Array.isArray(section.data) ? section.data : [];
    }

    // Filter columns based on visibility
    const columns = section.allColumns.filter(col => section.visibleColumns[col.key]);

    if (columns.length === 0) {
      return;
    }

    if (rows.length === 0) {
      return;
    }

    const header = columns.map(col => col.label);
    const data = rows.map(row => {
      return columns.map(col => {
        const v = row[col.key] ?? row[col.key.toLowerCase()] ?? '';
        return typeof v === 'object' ? JSON.stringify(v) : String(v);
      });
    });

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');

    const headerRow = worksheet.addRow(header);
    headerRow.font = { bold: true };
    headerRow.alignment = { vertical: 'middle', horizontal: 'center' };

    data.forEach(row => {
      worksheet.addRow(row);
    });

    worksheet.eachRow(row => {
      row.eachCell(cell => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });
    });

    worksheet.columns.forEach(col => {
      col.width = 30;
    });

    workbook.xlsx.writeBuffer().then(buffer => {
      const fileName = `application-dashboard-${section.title.replace(/\s+/g, '_')}.xlsx`;
      FileSaver.saveAs(
        new Blob([buffer]),
        fileName
      );
    });
  }

  showUploadModal(content: any) {
    this.showErrorBanner = false;
    console.log('SHOW MODAL CALLED');
    this.alertService.clear();
    try {
      const lingeringToasts = document.querySelectorAll('.toast-message, .alert-animate');
      lingeringToasts.forEach(el => el.parentElement?.removeChild(el));
    } catch { }

    this.uploadData = {
      file: null,
      category: '',
      docType: '',
      template: null,
      schoolYear: this.schoolYears[0]?.key || null
    };
    this.cdr.detectChanges();
    this.oneFileIsRequired = false;
    this.categoryError = '';
    this.docTypeError = '';
    this.filteredDocumentTypes = [];
    this.autoSelectSingleCategory();


    this.modalService.open(content, { size: 'lg', centered: true, backdrop: 'static', keyboard: false, windowClass: 'custom-lea-upload-modal' });
    this.authServices.clearFormAttachments();
  }

  private autoSelectSingleCategory(): void {
    if (this.categories && this.categories.length === 1) {
      this.uploadData.category = this.categories[0].key;
      this.onCategoryChange();
    }
  }

  onCategoryChange() {
    this.uploadData.docType = '';
    this.docTypeError = '';
    if (this.uploadData.category) {
    }

    this.cdr.detectChanges();
  }

  handleFileUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    let errorCount = this.uploadData.error_count || 0;
    if (!input.files || input.files.length === 0) {
      this.oneFileIsRequired = true;
      this.uploadData.file = null;
      this.uploadData.type = '';
      this.uploadData.fileName = '';
      errorCount++;
      this.uploadData.error_count = errorCount;
      return;
    }
    const file = input.files[0];
    const allowedTypes = [
      'text/csv',
      'application/csv',
      'application/vnd.ms-excel', // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // .xlsx
    ];
    const maxSize = 15 * 1024 * 1024;
    if (file.size > maxSize) {
      this.uploadError = this.errorMessage['M0128'] || 'The selected file exceeds the maximum allowed size of 15 MB.';
      errorCount++
      this.uploadData.file = null;
      this.uploadData.type = '';
      this.uploadData.fileName = '';
      this.uploadData.error_count = errorCount;
      if (this.fileInputRef && this.fileInputRef.nativeElement) {
        this.fileInputRef.nativeElement.value = '';
      }
      this.cdr.detectChanges();
      return;
    }
    if (!allowedTypes.includes(file.type)) {
      this.uploadError = this.errorMessage['M0129'] || 'The selected file type is not supported.';
      errorCount++
      this.uploadData.file = null;
      this.uploadData.type = '';
      this.uploadData.fileName = '';
      this.uploadData.error_count = errorCount;
      // Clear the file input so user must reselect
      if (this.fileInputRef && this.fileInputRef.nativeElement) {
        this.fileInputRef.nativeElement.value = '';
      }
      return;
    }
    // this.uploadData.error_count = errorCount;
    this.uploadData.file = file;
    this.uploadData.type = this.uploadData.type || file.type;
    this.uploadData.fileName = file.name;
    this.oneFileIsRequired = false;
    this.uploadError = null;
    this.saveEnable = false;
  }

  // closeUploadPopup() {
  //   // Show confirmation modal before closing
  //   if (this.uploadData.file || this.uploadData.fileName) {
  //     this.showCancelConfirmationModal();
  //   } else {
  //     this._actuallyCloseUploadPopup();
  //   }
  // }

  // showCancelConfirmationModal() {
  //   const modalConfig = {
  //     heading: 'Cancel File Upload',
  //     modalContent: 'You have started uploading a file but have not yet saved it. Are you sure you want to cancel? Any unsaved changes will be lost.',
  //     buttons: [
  //       { text: 'Yes, Cancel', code: 'Y' },
  //       { text: 'No, Continue', code: 'N', btnOutline: true }
  //     ],
  //     isDangerButton: true,
  //     hideCloseIcon: true
  //   };
  //   const modalRef = this.modalService.open((window as any).ModalComponent, {
  //     backdrop: 'static',
  //     centered: true,
  //     size: 'md',
  //     windowClass: 'top-modal'
  //   });
  //   modalRef.componentInstance.modalConfig = modalConfig;
  //   modalRef.result.then((result: any) => {
  //     if (result && result.code === 'Y') {
  //       this._actuallyCloseUploadPopup();
  //     }
  //     // If 'N', do nothing (modal just closes)
  //   }, () => {});
  // }

  closeUploadPopup() {
    // Show confirmation modal before closing
    if (this.uploadData.file || this.uploadData.fileName || this.uploadData.template) {
      const modalRef = this.modalService.open(ModalComponent, { centered: true, windowClass: 'dashboard-no-header-border custom-lea-cancel-upload-modal', backdrop: 'static', keyboard: false });
      modalRef.componentInstance.modalConfig = this.getWelcomeModalConfig();
      modalRef.componentInstance.emitData.subscribe((data: any) => {
        if (data.buttonCode === 'Y') {
          // this._actuallyCloseUploadPopup();
          this.clearModalFields();
          this._actuallyCloseUploadPopup();
          this.saveEnable = false;
          this.uploadData.template = null;
        } else if (data.buttonCode === 'N') {
          const uploadModalTemplate = document.getElementById('uploadModel');
          if (uploadModalTemplate) {
            this.showUploadModal(uploadModalTemplate);
          }
          // Optionally handle "Maybe Later"
        }
        modalRef.close();
        this.cdr.detectChanges();
      });
    } else {
      this._actuallyCloseUploadPopup();
    }
  }

  private getWelcomeModalConfig(): ModalConfig {
    return {
      heading: 'Cancel File Upload',
      modalContent: 'You have started uploading a file but have not yet saved it. Are you sure you want to cancel? Any unsaved changes will be lost.',
      hasDropdown: false,
      hasTemplate: true, // To allow HTML in heading
      align: false,
      panelClass: 'cancelUploadModal epp-dashboard-uplaod-modal',
      buttons: [
        { text: 'Yes, Cancel', code: 'Y' },
        { text: 'No, Continue', code: 'N', btnOutline: true }
      ],
    };
  }

  private _actuallyCloseUploadPopup() {
    this.uploadError = null;
    this.uploadData.error_count = 0;
    try {
      const lingeringToasts = document.querySelectorAll('.toast-message, .alert-animate');
      lingeringToasts.forEach(el => el.parentElement?.removeChild(el));
    } catch { }
    this.authServices.clearFormAttachments();
    this.modalService.dismissAll();
    this.oneFileIsRequired = false;
    this.categoryError = '';
    this.docTypeError = '';
    this.filteredDocumentTypes = [];
    this.uploadData = {
      file: null,
      category: '',
      docType: ''
    };
  }

  clearFileInput(event: any) {
    event.target.value = null;
  }

  private clearModalFields() {
    this.uploadData = {
      file: null,
      category: '',
      docType: '',
    };
    this.uploadData.template = null;
  }

  onSave(): void {
      if (!this.uploadData.schoolYear) {
    this.schoolYearError = 'Please select a school year.';
    return;
  }
  this.schoolYearError = '';
    this.showText = true;
    this.saveEnable = true;
    this.loaderService.show();
    // Prepare signed URL request
    const signedUrlRequest = {
      file_name: this.uploadData.fileName,
      content_type: this.uploadData.type || ''
    };

    // Prepare document upload data
    const uploadData = {
      file_name: this.uploadData.fileName,
      registration_type: 'LEA', // Hardcoded as per your requirement
      template_name: this.uploadData.template || '',
      created_by: this.getUserId(),
      uploaded_by: this.getUserId(),
      status: 'Uploaded',
      error_count: this.uploadData.error_count || 0

    };
    // 👈 key must match backend

    let url = API_ENDPOINTS.DATA_TEMPLATES.UPLOAD_TEMPLATES;
    const formData = new FormData();
    formData.append('file', this.uploadData.file);
    formData.append('templateId', this.uploadData.template.template_id);
    formData.append('templatecolselId', this.uploadData.template.data_template_col_sel_id);
    formData.append('templateName', this.uploadData.fileName);
    formData.append('createdBy', this.getUserId());
    formData.append('uploadedBy', this.getUserId());
    formData.append('schoolYear', this.uploadData.schoolYear);

    // this.httpService.postFormData(url, formData)
    //   .subscribe((res:any) => {
    //     console.log(res); // ✅ JSON response
    //     if(res.data.totalErrorCount >= 0)
    //     {
    //       this.alertService.success(this.lookupToast?.['T0070']);
    //     }
    //     else
    //     {
    //        this.alertService.success(this.lookupToast?.['T0069']);
    //     }
    //     setTimeout(() => {
    //     this._actuallyCloseUploadPopup();
    //     this.fetchSubmissionsList();
    //     this.showText = false ;
    //     this.saveEnable = false;
    //     }, 5000);

    //   });
    this.httpService.postFormData(url, formData)
      .subscribe({
        next: (res: any) => {
          console.log('SUCCESS:', res);

          if (res?.data?.totalErrorCount > 0) {
            this.alertService.success(this.lookupToast?.['T0070'], false, 10000);
          } else {
            this.alertService.success(this.lookupToast?.['T0069'], false, 10000);
          }

          setTimeout(() => {
            this._actuallyCloseUploadPopup();
            this.fetchSubmissionsList();
            this.showText = false;
            this.saveEnable = false;
          }, 10000);
        },

        error: (error) => {
          // this.alertService.error('Invalid template: Column count mismatch. Do not add/remove columns.');
          this.errorBannerMessage = this.lookupErrorMessages?.['M0191'] || 'An error occurred.';
          this.showErrorBanner = true;
          // ❌ Do NOT close popup on error
          this.showText = false;
          this.saveEnable = true;
          this.alertService.clear();
        }
      });




    // Call backend API to get signed URL and save document
    // this.httpService.post('/lea-portal/portal-document-upload', {
    //   uploadData,
    //   signedUrlRequest
    // }).pipe(take(1), takeUntil(this.destroy$)).subscribe({
    //   next: (res: any) => {
    //     this.saveEnable = true;
    //     if (res?.status === 'success') {
    //       this.alertService.success('File uploaded and saved successfully.');
    //       // Optionally refresh submissions grid or data here
    //       this.loadPortalTemplate();
    //       this.loadPortalSubmission();
    //       this.uploadData.error_count = 0;
    //       this._actuallyCloseUploadPopup();
    //     } else {
    //       this.alertService.error(res?.message || 'Failed to save document upload.');
    //     }
    //     this.loaderService.hide();
    //   },
    //   error: (error) => {
    //     this.alertService.error('Failed to upload and save document. Please try again.');
    //     this.saveEnable = true;
    //     this.loaderService.hide();
    //   }
    // });
  }

  /**
  * Utility method to retrieve user ID from various sources
  */
  getUserId(): string | null {
    let userObj = this.commonService.getCurrentUserData();

    if (!userObj) {
      const userFromSession = this.sessionStorage.getItem('user');
      if (userFromSession) {
        userObj = JSON.parse(userFromSession);
      }
    }

    if (!userObj) {
      return null;
    }

    return userObj?.id || userObj?.user_id || userObj?.userId || null;
  }

  loadPortalTemplate() {
    const userId = this.getUserId();
    console.log('USER ID', userId)
    if (!userId) {
      this.alertService.error('User information not found. Please login again.');
      return;
    }
    const payload = { userId, registrationType: LEA_PORTAL_CONSTANT.LEA_TEMPLATE };
    console.log(API_ENDPOINTS.PORTAL_TEMPLATE, 'API')
    this.httpService.post(API_ENDPOINTS.PORTAL_TEMPLATE, payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          let gridData = []
          if (response?.status === 'success' && response?.data?.data?.[0]) {
            console.log('RESPONSE', response);
            gridData = response.data.data;
            console.log('GRID DATA:', gridData);
            //  this.mapTemplateData(gridData)
            this.templateOptions = Array.from(new Set(gridData.map((item: any) => item.template_name).filter(Boolean)));
            this.sectionManager.updateSectionData('dataTemplateHeaders', gridData);
          } else {
            this.alertService.error('Failed to load template data.');
          }
        },
        error: (error) => {
          this.alertService.error('Failed to load portal template data. Please try again.');
          this.isLoading = false;
          this.loaderService.hide();
        },
        complete: () => {
          this.isLoading = false;
          this.loaderService.hide();
        }
      })
  }
  loadPortalSubmission() {
    const userId = this.getUserId();
    console.log('USER ID', userId)
    if (!userId) {
      this.alertService.error('User information not found. Please login again.');
      return;
    }
    const payload = { userId, registrationType: LEA_PORTAL_CONSTANT.LEA_SUBMISSION };
    console.log(API_ENDPOINTS.PORTAL_TEMPLATE, 'API')
    this.httpService.post(API_ENDPOINTS.PORTAL_TEMPLATE, payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          let gridData = []
          if (response?.status === 'success' && response?.data?.data?.[0]) {
            console.log('Submission API response:', response);
            gridData = response.data.data;
            //  this.mapTemplateData(gridData)
            this.sectionManager.updateSectionData('dataSubmissionHeaders', gridData);
          } else {
            this.alertService.error('Failed to load template data.');
          }
        },
        error: (error) => {
          this.alertService.error('Failed to load portal template data. Please try again.');
          this.isLoading = false;
          this.loaderService.hide();
        },
        complete: () => {
          this.isLoading = false;
          this.loaderService.hide();
        }
      })
  }

  downloadTemplate(data: any): void {
    console.log('Downloading document for row:', data);
    if (!data || !data.portal_document_upload_id) {
      this.alertService.error('Document information is missing');
      return;
    }

    this.loaderService.show();

    const payload = {
      portal_document_upload_id: data.portal_document_upload_id,
    };

    this.httpService
      .post(API_ENDPOINTS.PORTAL_DOCUMNET_DOWNLOAD, payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.status === 'success' && response?.data?.data?.p_document_blob?.file_hash) {
            const fileUrl = response.data.data.p_document_blob.strfileHash;
            // Fetch the file and download it to the system (no preview, no new tab)
            fetch(fileUrl)
              .then(res => res.blob())
              .then(blob => {
                const fileName = data.file_name;
                FileSaver.saveAs(blob, fileName);
                this.alertService.success('Document downloaded successfully');
              })
              .catch(error => {
                this.alertService.error('Failed to download document file');
              })
              .finally(() => {
                this.loaderService.hide();
              });
          } else {
            this.alertService.error('Failed to download document');
            this.loaderService.hide();
          }
        },
        error: (error) => {
          this.alertService.error('Failed to download document. Please try again.');
          this.loaderService.hide();
        }
      });
  }

  onTemplateBlur(event: any) {
    console.log(event);
    if (!this.uploadData.template) {
      this.templateError = 'Please select a category.';
    } else {
      this.templateError = '';
      this.saveEnable = false;
    }

    // if(this.uploadData.template?.data_template_col_sel_id != undefined)
    // {
    //   this.uploadData.template.template_id = this.uploadData.template?.data_template_col_sel_id ;
    // }

  }

  onEditorPrepared(e: any): void {
    const dateColumns = ['updated_date', 'uploaded_at'];

    if (dateColumns.includes(e.dataField)) {
      e.editorElement?.addEventListener('input', (event: any) => {
        let v = event.target.value.replace(/\D/g, '').slice(0, 8);
        event.target.value = v.replace(/(\d{2})(\d{2})?(\d{0,4})?/, (_, m, d, y) =>
          [m, d, y].filter(Boolean).join('/')
        );
      });
    }
  }

  getErrorMessages(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.systemConfigurationService.getErrorMessages().subscribe({
        next: (data: any) => {
          resolve();
          console.log(data?.data);
          const transformLookupArray = (arr: any[]): { [key: string]: string } => {
            const obj: { [key: string]: string } = {};
            if (Array.isArray(arr)) {
              arr.forEach(lookupItem => {
                if (lookupItem.key && lookupItem.value) {
                  obj[lookupItem.key] = lookupItem.value;
                }
              });
            }
            return obj;
          };
          this.lookupErrorMessages = transformLookupArray(data?.data);
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  removeFileExtension(name: string): string {
    if (!name) return '';
    const lastDot = name.lastIndexOf('.');
    return lastDot > 0 ? name.substring(0, lastDot) : name;
  }

// loadSchoolYears() {
//   this.httpService.get(API_ENDPOINTS.lookupSchoolYears)
//     .pipe(take(1), takeUntil(this.destroy$))
//     .subscribe({
//       next: (response: any) => {
//         this.schoolYears = response?.data || [];
//       },
//       error: () => {
//         this.alertService.error('Failed to load school years. Please try again.');
//       }
//     });
// }

loadSchoolYears() {
  const { startYear, endYear } = this.getCurrentSchoolYear();
  const label = `${startYear} - ${endYear}`;
  this.schoolYears = [
    { key: label, value: label }
  ];
}



  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
